export default __webpack_public_path__ + "static/media/wycjy.efcac770.png";